import Header, { CancelButton, RenderAddress } from './components';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { addressComponents } from './index';
import ActionButton from 'components/ActionButton';
import { reverseGeoCode } from 'services';

const LocationDetails = (props) => {
  const {
    setComponentToShow,
    localAddress = {},
    setLocalAddress,
    handleClose,
    isVisible = true,
  } = props;
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    if(!localAddress?.objectId){
      getUserCurrentLocation();
    }
  }, []);

  const onClickContinue = async () => {
    try {
      setLoading(true);
      const addressDetails = await reverseGeoCode(localAddress?.coords);
      setLocalAddress({
        ...localAddress,
        town: addressDetails?.town,
        zip: addressDetails?.zip,
        number: addressDetails?.number,
      });
      setComponentToShow(addressComponents.addressDetails);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const getUserCurrentLocation = async () => {
    setLoading(true);
    navigator.geolocation.getCurrentPosition(async function (position) {
      const latLng = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      const addressDetails = await reverseGeoCode(latLng);
      setLocalAddress({
        ...localAddress,
        coords: latLng,
        address: addressDetails?.address,
      });
      setLoading(false);
    }, () => {
      setLoading(false);
    });
  };

  const getCtaText = () => {
    return loading ? 'Fetching location details' : 'Continue';
  };

  const onClickChangeAddress = () => {
    setComponentToShow(addressComponents.searchLocation);
  };

  if(!isVisible) return null;

  return (
    <div className="col-12">
      <Header title="Select your location" onClose={handleClose} />
      <span className={styles['location-label']}>Delivery Area</span>
      <RenderAddress 
        address={localAddress?.address} 
        onClick={onClickChangeAddress}
        onClickCurrentLocation={getUserCurrentLocation}
      />
      <div className="d-flex align-items-center justify-content-between mt-2">
        <CancelButton onCancel={handleClose} />
        <ActionButton
          text={getCtaText()}
          onClick={onClickContinue}
          active={!loading}
          isLoading={loading}
        />
      </div>
    </div>
  );
};
export default LocationDetails;
